<script>
import PhxPicture from '@maison/components/common/PhxPicture.vue';

export default {
  components: {
    PhxPicture,
  },

  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    url: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    variationCount: {
      type: Number,
      required: true,
    },
    additionalClasses: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    getModelCardClasses() {
      return ['product-card', ...this.additionalClasses];
    },
  },
};
</script>

<template>
  <div :class="getModelCardClasses">
    <div class="picture product-card__picture picture--contain">
      <PhxPicture lazy v-bind="image" class="phx-picture-variant" />
    </div>

    <div class="product-card__description">
      <a :href="url" class="product-card__link expand-target">
        <div class="product-card__name">{{ name }}</div>
        <div class="product-card__collection"></div>

        <div class="product-price product-price--small">
          <span class="product-price__value">
            {{ $t('Models.variationCount', { variations: variationCount }) }}
          </span>
        </div>
      </a>
    </div>
  </div>
</template>
